export const extractYoutubeVideoId = (html: string | null): string | null => {
    if (!html) {
        return null;
    }

    const match = html.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);

    return match ? match[1] : null;
};
